import React, { useMemo } from 'react';
import { GoogleButton as SeagullGoogleButton, useMediaQueries } from 'seagull';
import { handleRequest, sendErrReport } from "../../infra/utils";
import { useStoreActions } from "../../store/store-context";
import styles from "./GoogleButton.module.scss";
import { useUtmsParams } from "../../hooks/useUtmsParams";
import { errorMessages } from "../../pages/unAuthorizedPages/constants";
import { useLocationCommonActions } from "../../providers/LocationProvider";
import { routes } from "../../constants";
import { useEventReporter } from "../../event-reporter";
import { isMobileDevice } from "../../infra/device";
import { useIoContext } from "../../contexts";
export default function GoogleButton(props) {
  const {
    ensureEmail,
    testid,
    onAuthSuccess,
    onAuthError
  } = props;
  const {
    reportToGtm,
    reportToAppcues,
    reportToHubspot,
    reportToHeap
  } = useEventReporter();
  const {
    setAuthToken,
    api,
    logBI
  } = useStoreActions();
  const {
    mobile
  } = useMediaQueries();
  const getUtms = useUtmsParams();
  const {
    getPageUrl
  } = useLocationCommonActions();
  const {
    locationReload
  } = useIoContext();
  const buttonConfiguration = useMemo(() => {
    return {
      type: 'standard',
      locale: 'en_US',
      width: mobile ? 280 : 400,
      text: 'continue_with',
      theme: 'outline',
      logo_alignment: 'center',
      size: 'large'
    };
  }, [mobile]);

  async function onGoogleAuth(_ref) {
    var _response$data;

    let {
      credential
    } = _ref;
    const [response, err, hasError] = await handleRequest(api.auth.googleSignIn({
      pageUrl: getPageUrl(),
      idToken: credential,
      utms: getUtms(),
      ensureEmail
    }));

    if (hasError) {
      var _err$response, _err$response2;

      if (((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data) === 'invalid auth request: email does not match') {
        const currentPathWithLoginError = "".concat(location.pathname).concat(routes.loginError);
        location.assign(currentPathWithLoginError);
      }

      if (((_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) === 'invalid auth request: email is invalid') {
        onAuthError && onAuthError(errorMessages.noBusinessEmailError);
      } else {
        var _err$response3, _err$response4;

        sendErrReport((_err$response3 = err.response) !== null && _err$response3 !== void 0 && _err$response3.data ? "GoogleButton - ".concat((_err$response4 = err.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.data) : err);
        onAuthError && onAuthError();
      }
    } else if (((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.token) != null) {
      reportToGtm('form-success', 'google-sign-in');
      reportToAppcues('form-success', 'google-sign-in');
      reportToHubspot('google_sign_in');
      reportToHeap('googleSignIn', 'form-success', 'google-sign-in');
      logBI(11801);

      if (isMobileDevice) {
        locationReload();
      } else {
        try {
          await setAuthToken(response.data.token);
          onAuthSuccess && onAuthSuccess();
        } catch (e) {
          sendErrReport('GoogleButton - failed to set an auth token');
          onAuthError && onAuthError();
        }
      }
    } else {
      sendErrReport('GoogleButton - did not retrieve an auth token');
      onAuthError && onAuthError();
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testid || 'google-login',
    className: styles.buttonContainer
  }, /*#__PURE__*/React.createElement(SeagullGoogleButton, {
    googleClientId: window.googleAuthClientId,
    callback: onGoogleAuth,
    buttonConfiguration: buttonConfiguration
  }));
}